import moment from 'moment';

export const diasRestantesVigencia = (fechaVencimiento) => {
  if (!fechaVencimiento) return null;
  return moment(fechaVencimiento).startOf('day').diff(moment().startOf('day'), 'days');
};

export const formatearVigencia = (meses) => {
  const numero = Number(meses);
  if (meses === null || meses === undefined || Number.isNaN(numero)) return 'N/A';
  if (numero >= 12 && numero % 12 === 0) {
    const anios = numero / 12;
    return anios === 1 ? '1 año' : `${anios} años`;
  }
  return `${numero} meses`;
};
